import type { MenuItem } from "../types";
import { formatCurrency } from "../lib/format";
import { useCart } from "../lib/cart";
import { Button } from "./Button";

type ProductCardProps = {
  item: MenuItem;
  circular?: boolean;
  compact?: boolean;
};

export function ProductCard({ item, circular = false, compact = false }: ProductCardProps) {
  const cart = useCart();

  return (
    <article className={`product-card ${circular ? "product-card-round" : ""}`} data-testid={`product-${item.id}`}>
      <img src={item.image} alt={item.name} loading="lazy" />
      <div className="product-card-copy">
        <h3>{item.name}</h3>
        <p>{item.subtitle}</p>
        {!compact ? <span>{formatCurrency(item.priceCents)}</span> : null}
      </div>
      {!compact ? (
        <Button
          variant="ghost"
          data-testid={`add-menu-${item.id}`}
          onClick={() =>
            cart.addItem({
              id: item.id,
              kind: "menu",
              name: item.name,
              subtitle: item.subtitle,
              priceCents: item.priceCents,
              image: item.image
            })
          }
        >
          Add to cart
        </Button>
      ) : null}
    </article>
  );
}
